<template>
  <p>People stub for 2018</p>
</template>
